export default __webpack_public_path__ + "static/media/communityIcon.b522b005.svg";